// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"173":"27e97be9","387":"8696bfbc","512":"40f1a579"}[chunkId] + ".chunk.js";
};